import React from 'react'
import {
  PromotionModal,
  PromotionModalOptions,
} from '@vend/business-components'
import { reactular } from '@vendhq/reactular'

interface Props {
  close: (val?: Promise<any>) => void
  options: PromotionModalOptions
}

const PromotionModalWrapper: React.FC<Props> = ({ close, options }) => {
  return <PromotionModal close={close} options={options}></PromotionModal>
}

const vbPromotionModal = reactular(
  PromotionModalWrapper,
  ['close', 'options'],
  'reactWrapper'
)

export { vbPromotionModal }
